import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { PasswordValidator } from 'src/app/shared/password-validator';
import { CommonService } from 'src/app/shared/services/common.service';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: []
})
export class PrivacyPolicyComponent implements OnInit {

  @Output() tabChange: EventEmitter<any> = new EventEmitter();
  signUpForm: FormGroup;
  constructor(private formBuilder: FormBuilder,
    private router: Router) { }

  ngOnInit(): void {
    
  }


}

